import { Show } from "solid-js";
import { useParams, Navigate } from "@solidjs/router";
import { clientOnly } from "@solidjs/start";
import { LocaleProvider, SUPPORTED_SEGMENTS, localeForSegment } from "~/context/locale";

const UpdateWatcher = clientOnly(() => import("@/components/update-watcher"));
const LanguageSuggestion = clientOnly(() => import("@/components/language-suggestion"));

export default function LangLayout(props) {
  const params = useParams();
  return (
    <Show when={params.lang} keyed>
      <LocaleProvider locale={localeForSegment(params.lang)}>
        <Show when={SUPPORTED_SEGMENTS.includes(params.lang)} fallback={<Navigate href="/en" />}>
          {props.children}
          <UpdateWatcher />
          <LanguageSuggestion />
        </Show>
      </LocaleProvider>
    </Show>
  );
}
